import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import NotificationForm from '../components/NotificationForm';
import { useNotificationDetails } from '../hooks/useNotificationDetails';
import { useUpdateNotification } from '../hooks/useNotificationMutations';

export default function NotificationEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading: loadingDetails } = useNotificationDetails(id);
  const mutation = useUpdateNotification();

  const handleSubmit = (formData: any) => {
    (mutation.mutate as any)({ id, data: formData }, { onSuccess: () => navigate('/notifications') });
  };

  if (loadingDetails) return <Spin style={{ display: 'block', margin: '80px auto' }} />;

  return (
    <div>
      <PageHeader back title={t('notifications.editTitle')} subtitle={`${t('common.edit')}: ${data?.titleEn || ''}`} />
      <Card>
        <NotificationForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
